console.log('Test console OK');

console.log('[Logo Debug] Script chargé');

document.addEventListener('DOMContentLoaded', function () {
  var logoContainers = document.querySelectorAll('.header-logo__image-container');
  if (!logoContainers.length) return;

  /** @type {number|null} */
  var initialHeaderTop = null;
  var header = document.getElementById('header-component');
  if (header) {
    initialHeaderTop = header.getBoundingClientRect().top;
    console.log('[Logo Debug] Position initiale header:', initialHeaderTop);
  }

  /**
   * @param {HTMLElement} container
   */
  function getLogoWidths(container) {
    var styles = getComputedStyle(container);
    return {
      desktop: styles.getPropertyValue('--header-logo-image-width') || '120px',
      sticky: styles.getPropertyValue('--header-logo-image-width-sticky') || '80px',
      mobile: styles.getPropertyValue('--header-logo-image-width-mobile') || '100px',
    };
  }

  function isStickyNow() {
    if (!header || initialHeaderTop === null) return false;
    var currentTop = header.getBoundingClientRect().top;
    var sticky = window.innerWidth >= 750 && currentTop < initialHeaderTop - 1;
    console.log('[Logo Debug] ScrollY:', window.scrollY, '| header.top:', currentTop, '| sticky:', sticky);
    return sticky;
  }

  function fixLogoImages() {
    document.querySelectorAll('.header-logo__image').forEach(function(img) {
      var el = /** @type {HTMLImageElement} */ (img);
      el.removeAttribute('width');
      el.removeAttribute('height');
      el.style.width = '100%';
      el.style.height = 'auto';
      el.style.maxWidth = '100%';
      el.style.minWidth = '0';
      el.style.objectFit = 'contain';
      el.style.display = 'block';
    });
  }

  function updateLogoWidth() {
    var isMobile = window.innerWidth < 750;
    var isSticky = isStickyNow();
    logoContainers.forEach(function(container) {
      var el = /** @type {HTMLElement} */ (container);
      var widths = getLogoWidths(el);
      if (isMobile) {
        el.style.width = widths.mobile.trim();
      } else if (isSticky) {
        el.style.width = widths.sticky.trim();
      } else {
        el.style.width = widths.desktop.trim();
      }
    });
    fixLogoImages();
  }

  window.addEventListener('scroll', updateLogoWidth, { passive: true });
  window.addEventListener('resize', updateLogoWidth);
  window.addEventListener('orientationchange', updateLogoWidth);

  updateLogoWidth();
}); 